import Marquee from "react-fast-marquee";

export default function BrandMarquee() {
  const items = [
    "ALLSTAR",
    "ALL BLACK",
    "STREETWEAR",
    "DROP 01",
    "BUILT DIFFERENT",
    "SINCE 2025",
  ];
  return (
    <div
      data-testid="brand-marquee"
      className="border-y border-zinc-900 bg-black py-6 overflow-hidden"
    >
      <Marquee speed={60} gradient={false} pauseOnHover>
        {items.map((text, i) => (
          <span
            key={i}
            className="font-display text-5xl md:text-7xl uppercase tracking-tighter mx-10 flex items-center"
          >
            {text}
            <span className="text-green-400 mx-10">★</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
